import React, { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useErrorHandler } from "react-error-boundary";
import styled from "styled-components";
import { Booking } from "../../../types";
import { config } from "../../../config";
import { bookingStore } from "../../../stores/booking.store";
import {
  cancelPendingBookingRequest,
  commitPendingBooking,
} from "../../../requests/pending-booking.requests";
import { buildRouteWithParams } from "../../../helpers/build-route-with-params";
import { InformationText } from "../../information-text/information-text";
import { Loader } from "../../loader/loader";
import { ApiErrorCode } from "../../../services/api-errors";
import { SetupIntentApiErrorImpl } from "../../../services/api-errors/api-errors-impl";
import { moduleSettings } from "../../../stores/module-settings.store";

const RefreshOnPaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const _RefreshOnPayment = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const _pendingBookingId = localStorage.getItem("pendingBookingId") || "";
  const _referralKey = localStorage.getItem("referralKey" || "");
  const throwError = useErrorHandler();

  const clearLocaleStorage = () => {
    localStorage.removeItem("pendingBookingId");
    localStorage.removeItem("referralKey");
  };

  useEffect(() => {
    // if (window.performance && performance.navigation.type == 1) {
    if (_pendingBookingId && _referralKey === moduleSettings.getReferralKey()) {
      const subscription = commitPendingBooking({
        pending_booking_id: _pendingBookingId,
      }).subscribe({
        next: (resp: Booking) => {
          clearLocaleStorage();
          bookingStore.booking = resp;
          history.push(buildRouteWithParams(config.routes.confirmationEnd));
        },
        error: (error) => {
          clearLocaleStorage();
          let err = {};
          if (
            error.code === ApiErrorCode.setup_intent_invalid ||
            error.code === ApiErrorCode.payment_intent_failed
          ) {
            cancelPendingBookingRequest(_pendingBookingId);
            err = new SetupIntentApiErrorImpl(error);
          }
          throwError(err);
        },
      });
      return () => {
        subscription.unsubscribe();
      };
    }
    // }
  }, [window.performance]);

  return (
    <RefreshOnPaymentWrapper>
      <InformationText
        key={"no_online_booking_enabled_msg"}
        text={t("instabook.errors.error_during_payment")}
        status={"info"}
      />
      <Loader />
    </RefreshOnPaymentWrapper>
  );
};

export const RefreshOnPayment = memo(_RefreshOnPayment);
